import { FEATURE_ENUM } from '@partoohub/api-client';

import { ADMIN } from 'app/common/data/roles';
import { useHasFeature } from 'app/common/hooks/accessesAndPermissions/pages/useHasFeature';
import { useMe } from 'app/pages/app/AppDataProvider/hooks/useMe';

export const useHasPresenceAnalyticsPage = (): boolean => {
    const me = useMe();

    if (me.role === ADMIN) {
        return false;
    }

    return useHasFeature(FEATURE_ENUM.PRESENCE_ANALYTICS);
};
